import { Image } from 'app/components/ui/Image'
import { Title } from 'app/components/ui/Title'
import React from 'react'
import styled from 'styled-components'

type Props = {
  title: string
}

export const UploadFileSection = ({
  title,
  children,
}: WithChildren<Props>): JSX.Element => {
  return (
    <FormSectionWrapper>
      <TitleWrapper>
        <Image
          src='https://res.cloudinary.com/estra/image/upload/v1629357549/estra20dev/sponsor/upload_icon.svg'
          alt='form_step_icon'
        ></Image>
        <Title size={3}>{title}</Title>
      </TitleWrapper>
      {children}
    </FormSectionWrapper>
  )
}

const FormSectionWrapper = styled.div``

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;

  margin-bottom: 3rem;

  img {
    margin-right: 1rem;
  }
`
